import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actionCreators } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";
import { useEffect } from "react";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const useGarageChainParameters = () => {
  const dispatch = useDispatch();
  const { changeGarageChain } = bindActionCreators(actionCreators, dispatch);
  const [searchParams] = useSearchParams();

  const garageChainQuery = searchParams.get("garage_chains");

  const garageChains = garageChainQuery?.split(",");

  const mappedArray = garageChains?.map((garageChain) => {
    return { id: parseInt(garageChain) };
  });

  useEffect(() => {
    changeGarageChain(mappedArray);
  }, [garageChainQuery]);

  const garageChainQueryParams = (): Record<string, string> => {
    return {
      ...(garageChains &&
        garageChains.length > 0 && {
          garage_chains: mappedArray
            ?.map((garageChain) => {
              return garageChain.id;
            })
            .join(","),
        }),
    };
  };

  return { garageChainQueryParams };
};
